import * as Yup from "yup";
import {
  noSpecialCharsYupTest,
  SPECIAL_CHARS_VALIDATION_MESSAGE,
} from "../utils/inputValidation";

export const addRoleSchema = Yup.object().shape({
  role_name: Yup.string()
    .trim()
    .test(
      "no-special-chars",
      SPECIAL_CHARS_VALIDATION_MESSAGE,
      noSpecialCharsYupTest
    )
    .required("Role name is required")
    .min(2, "Role name must be at least 2 characters")
    .max(50, "Role name cannot exceed 50 characters"),
  role_description: Yup.string()
    .trim()
    .test(
      "no-special-chars",
      SPECIAL_CHARS_VALIDATION_MESSAGE,
      noSpecialCharsYupTest
    )
    .max(500, "Description cannot exceed 500 characters"),
});

export const editRoleSchema = Yup.object().shape({
  role_name: Yup.string()
    .trim()
    .test(
      "no-special-chars",
      SPECIAL_CHARS_VALIDATION_MESSAGE,
      noSpecialCharsYupTest
    )
    .required("Role name is required")
    .min(2, "Role name must be at least 2 characters")
    .max(50, "Role name cannot exceed 50 characters"),
  role_description: Yup.string()
    .trim()
    .test(
      "no-special-chars",
      SPECIAL_CHARS_VALIDATION_MESSAGE,
      noSpecialCharsYupTest
    )
    .max(500, "Description cannot exceed 500 characters"),
});
